import { apiClient } from './api';

export interface EmailVerificationStatus {
  verified: boolean;
  tokenExpiry?: string;
  canResend: boolean;
}

export interface VerificationResult {
  success: boolean;
  message: string;
  user?: {
    id: string;
    email: string;
    name: string;
    emailVerified: boolean;
  };
}

class AuthService {
  /**
   * Verify email using token
   */
  async verifyEmail(token: string): Promise<VerificationResult> {
    return await apiClient.verifyEmail(token);
  }

  /**
   * Resend verification email
   */
  async resendVerificationEmail(): Promise<{ success: boolean; message: string }> {
    return await apiClient.resendVerificationEmail();
  }

  /**
   * Get email verification status for current user
   */
  async getEmailVerificationStatus(): Promise<EmailVerificationStatus> {
    return await apiClient.getEmailVerificationStatus();
  }

  /**
   * Request password reset
   */
  async requestPasswordReset(email: string): Promise<{ success: boolean; message: string }> {
    return await apiClient.requestPasswordReset(email);
  }

  /**
   * Reset password using token
   */
  async resetPassword(token: string, password: string): Promise<VerificationResult> {
    return await apiClient.resetPassword(token, password);
  }

  /**
   * Resend verification email for a specific user (admin function)
   */
  async resendVerificationEmailForUser(userId: string): Promise<{ success: boolean; message: string }> {
    return await apiClient.resendVerificationEmailForUser(userId);
  }
}

export const authService = new AuthService();
